export default {
  color: 'text',
  textDecoration: 'underline',
  fontWeight: 500,
  hover: {
    textDecoration: 'underline'
  }
}
